import { COMPANY_ADDRESS_FULL, COMPANY_LOCATION, COMPANY_REGION, MAP_URL } from '../constants';

function VisitSection() {
  return (
    <section id="visit" className="relative overflow-hidden bg-plum text-petal">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-rose/30 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-24 -left-10 h-72 w-72 rounded-full bg-sage/20 blur-3xl"
      />
      <div className="relative mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[0.85fr_1.15fr] lg:items-center">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.22em] text-blush">
            A note on place
          </p>
          <h2 className="font-display mt-3 text-4xl text-petal sm:text-5xl">
            {COMPANY_LOCATION}
          </h2>
          <p className="mt-5 max-w-md leading-8 text-petal/75">
            Haus Of Vellichor is registered in {COMPANY_REGION}. The address
            below is provided for public correspondence and directory listings.
          </p>
        </div>

        <div className="relative rounded-[2rem] border border-petal/15 bg-white/10 p-8 backdrop-blur">
          <div className="absolute -top-4 left-8 inline-flex items-center gap-2 rounded-pill bg-rose px-4 py-1.5 text-[11px] font-black uppercase tracking-[0.2em] text-petal">
            Public correspondence
          </div>
          <p className="font-display mt-3 text-3xl leading-snug text-petal sm:text-4xl">
            {COMPANY_ADDRESS_FULL}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={MAP_URL}
              target="_blank"
              rel="noreferrer"
              className="rounded-pill bg-petal px-6 py-3 font-semibold text-plum transition hover:bg-blush"
            >
              Open in Google Maps
            </a>
            <a
              href="#top"
              className="rounded-pill border border-petal/30 px-6 py-3 font-semibold text-petal transition hover:bg-petal/10"
            >
              Back to top
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VisitSection;
